import { configureStore } from "@reduxjs/toolkit";
import navSlice from "../feature/navToggle/navSlice";
import portfolioSlice from "../feature/portfolio/portfolioSlice";

import postSlice from "../feature/posts/postSlice";

const store = configureStore({
  reducer: {
    posts: postSlice,
    portfolio: portfolioSlice,
    toggle: navSlice,
  },
});

export default store;
